import { render, staticRenderFns } from "./SearchTecnico.vue?vue&type=template&id=3dd07038"
import script from "./SearchTecnico.vue?vue&type=script&lang=js"
export * from "./SearchTecnico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports